import { Link } from 'react-router';
import type { QuestGiverView, ZoneData } from '@thottbot/shared';
import { FieldTable, Prose } from './FieldTable';
import { ZoneMap } from './ZoneMap';

export function ZoneFields({
  data,
  name,
  questGivers = [],
}: {
  data: ZoneData;
  name: string;
  questGivers?: QuestGiverView[];
}) {
  const level =
    data.levelMin !== undefined && data.levelMax !== undefined
      ? `${data.levelMin} - ${data.levelMax}`
      : (data.levelMin ?? data.levelMax);
  const map = (
    <ZoneMap
      zone={{ name, areaId: data.areaId }}
      mapUrl={data.mapUrl}
      groups={questGivers.map((g) => ({
        label: g.name,
        href: `/npc/${g.slug}`,
        locations: g.locations,
      }))}
    />
  );
  return (
    <FieldTable
      rows={[
        { label: 'Continent', value: data.continent },
        { label: 'Level range', value: level },
        { label: 'Faction', value: data.faction },
        { label: 'Description', value: <Prose text={data.description} /> },
        {
          label: 'Loading screen',
          value: data.loadingScreenUrl && (
            <img className="zone-loading-screen" src={data.loadingScreenUrl} alt={`${name} loading screen`} />
          ),
        },
        {
          label: questGivers.length ? 'Quest givers' : 'Map',
          value: questGivers.length
            ? map
            : data.mapUrl && <img className="zone-map-plain" src={data.mapUrl} alt={`${name} map`} />,
        },
        {
          label: 'Minimap',
          value: data.minimapUrl && <img className="zone-minimap" src={data.minimapUrl} alt={`${name} minimap`} />,
        },
        {
          label: 'Browse',
          value: (
            <>
              <Link to={`/browse/quest?zone=${encodeURIComponent(name)}`}>Quests</Link>
              {' · '}
              <Link to={`/browse/npc?zone=${encodeURIComponent(name)}`}>NPCs</Link>
              {' · '}
              <Link to={`/browse/object?zone=${encodeURIComponent(name)}`}>Objects</Link>
            </>
          ),
        },
      ]}
    />
  );
}
